import { LOCAL_STORAGE_KEYS } from 'constant/localStorage';
import { getServerName } from './functions/server';
import { ServerName } from 'types/config';

interface Headers {
  Authorization: string;
  'tenant-id'?: string;
  'X-Screen-Name'?: string;
  // 'X-Trace-Id'?: string;
  // 'X-Parent-Span-Id'?: string;
  'X-Client-Platform'?: 'web' | 'mobile';
  'X-Server-Name'?: ServerName;
}

export default function globalHeaders(
  includeTenantId: boolean = true,
): Headers | null {
  const token = localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);
  const tenant = localStorage.getItem(LOCAL_STORAGE_KEYS.TENANT);
  const screenName = window.location.pathname;

  if (!token) {
    return null;
  }

  const headers: Headers = {
    Authorization: `Bearer ${token}`,
  };

  if (screenName) {
    headers['X-Screen-Name'] = screenName;
    headers['X-Client-Platform'] = 'web';
    // headers['X-Trace-Id'] = '';
    // headers['X-Parent-Span-Id'] = '';
    headers['X-Server-Name'] = getServerName() as ServerName;
  }

  if (includeTenantId && tenant) {
    headers['tenant-id'] = tenant;
  }

  return headers;
}
